/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
const globals = {
    "BSC": {
        "protocol" : "0x1695c4955F9c55e2B1317C59EBae60DE7B78ebf3",
        "stakingFactory": "0xB367B2b0Eedb258714631239Ace5f728171489B7"
        ,
        "airdrop": "0xA9341023341B0cbd3849afE4e7694a984313db83"
    }
    ,
    "BSC-Test": {
        "protocol" : "0x1c95b271f371db1ed652b653a5f12fea0799a72f",
        "stakingFactory": "0x78648E0Ab8bf2945eE2d695170Bd329C13362B5B"
        ,
        "airdrop": "0x52F238Bba81f1426b96c6d906DF0A653133cB055"
    },
    "Polygon": {
        "protocol" : "0xa48963ac5da6d5eb9024152ab0acfdbc3a30113d",
        "stakingFactory": "0x097BdD229e66033919f68887963280D052bCFec4",
        "airdrop": "0x30E25b5FD8c44dbDA9A7aca0aB6945a8b163B1A8"
    },
    "localhost" : {
        "protocol" : "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9",
        "stakingFactory": "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
        "airdrop": "0x0165878A594ca255338adfa4d48449f69242Eb8F"
    }
};

export default globals;
